import HTTP from '@/utils/http';
import Axios from 'axios';

export default function searcher(url, name) {
  const lowerName = (name || url).toLowerCase();
  const upperName = `${lowerName[0].toUpperCase()}${lowerName.slice(1)}`;

  const isSearching = `isSearching${upperName}`;
  const searchResults = `${lowerName}SearchResults`;
  const searchResultsComplete = `${lowerName}SearchResultsComplete`;
  const cancelSource = `${lowerName}CancelSource`;

  return {
    data() {
      return {
        [isSearching]: false,
        [searchResults]: [],
        [searchResultsComplete]: false,
        [cancelSource]: Axios.CancelToken.source(),
      };
    },
    methods: {
      async [`search${upperName}`]({ query, limit = 25 } = {}) {
        this[isSearching] = true;

        // cancel the in flight request
        this[cancelSource].cancel('wait');
        // refresh cancel token for this request
        this[cancelSource] = Axios.CancelToken.source();

        // make the request
        try {
          const response = await HTTP({
            url,
            params: {
              query,
              limit,
            },
            cancelToken: this[cancelSource].token,
          });

          // did we get all results on first page
          this[searchResultsComplete] =
            response?.data?.meta?.current_page ===
            response?.data?.meta?.last_page;

          // results!!!
          this[searchResults] = response?.data?.data || [];
          this[isSearching] = false;

          // async request complete
          return;
        } catch (error) {
          // we cancelled the request so return empty list
          if (error.message === 'cancelled') {
            this[searchResults] = [];
            this[isSearching] = false;
            return;
          }

          // still searching
          if (error.message === 'wait') {
            return;
          }

          // re-throw unexpected errors
          this[isSearching] = false;
          throw error;
        }
      },
      [`cancel${upperName}Search`]() {
        this[cancelSource].cancel('cancelled');
      },
    },
  };
}
